import { ArrowLeft, Mail, CheckCircle2 } from 'lucide-react';
import { useState } from 'react';
import { FormButton } from './FormButton';

interface ResetByEmailScreenProps {
  onBack: () => void;
  userEmail?: string;
}

export const ResetByEmailScreen = ({
  onBack,
  userEmail = 'ana.garcia@example.com',
}: ResetByEmailScreenProps) => {
  const [email, setEmail] = useState(userEmail);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSendLink = () => {
    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      setLoading(false);
      setSuccess(true);
    }, 1500);
  };

  if (success) {
    return (
      <div className="min-h-screen bg-[#F7F8FA] flex items-center justify-center p-4">
        <div className="bg-white rounded-[16px] border border-[#E5E7EB] p-6 max-w-sm w-full text-center space-y-4">
          <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mx-auto">
            <CheckCircle2 className="w-8 h-8 text-green-600" />
          </div>
          <div>
            <h2 className="text-lg font-bold text-[#111827] mb-2">
              Listo, revisa tu correo
            </h2>
            <p className="text-sm text-[#6B7280]">
              Te enviamos un enlace para restablecer tu contraseña a{' '}
              <span className="font-medium text-[#111827]">{email}</span>
            </p>
          </div>
          <FormButton onClick={onBack}>
            Entendido
          </FormButton>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F7F8FA]">
      {/* Header */}
      <div className="bg-white border-b border-[#E5E7EB] sticky top-0 z-10">
        <div className="flex items-center gap-3 p-4">
          <button
            onClick={onBack}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-[#F7F8FA] transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-[#111827]" />
          </button>
          <h1 className="text-lg font-bold text-[#111827]">Restablecer por correo</h1>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 space-y-6">
        <div className="bg-[#FFF4ED] rounded-[12px] p-4 flex items-start gap-3">
          <Mail className="w-5 h-5 text-[#FF6A2A] flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-[#111827] mb-1">
              Enviaremos un enlace para restablecer tu contraseña
            </p>
            <p className="text-xs text-[#6B7280]">
              El enlace será válido por 24 horas
            </p>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-[#111827] mb-2">
            Correo electrónico
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 border-2 border-[#E5E7EB] rounded-[12px] focus:border-[#FF6A2A] focus:outline-none transition-colors"
            placeholder="tu@correo.com"
          />
        </div>

        <FormButton
          onClick={handleSendLink}
          loading={loading}
          disabled={!email}
        >
          Enviar enlace
        </FormButton>
      </div>
    </div>
  );
};
